import React from 'react'
import { MdOutlineClose } from 'react-icons/md';

const ViewMoreInfo = ({ isMoreInfoData, closeModal, calculatePositiveRating }) => {
    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50'>
            <div className=' w-11/12 lg:w-full max-w-xl md:max-h-[70vh] max-h-full p-6 bg-white rounded-lg shadow-md overflow-hidden overflow-y-auto'>
                <div className='flex justify-between items-center'>
                    <p className='font-bold text-black text-lg'>
                        More Info
                    </p>
                    <div className='bg-[#15A14A26] rounded-full flex justify-center items-center h-7 w-7 text-[#15A14A] cursor-pointer hover:bg-white ring ring-[#15A14A26] hover:scale-105 transition-all duration-700 blur-none'>
                        <MdOutlineClose
                            size={20}
                            className=' cursor-pointer'
                            onClick={closeModal}
                            title='Close'
                        />
                    </div>
                </div>


                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="mt-6 grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-2">
                        <div className="sm:col-span-2">
                            <div className="flex items-center space-x-4">
                                <img
                                    src={isMoreInfoData.advertiser?.profile}
                                    alt={isMoreInfoData.advertiser?.name}
                                    className="h-12 w-12 rounded-full"
                                    onError={(e) => {
                                        e.target.src = 'https://via.placeholder.com/48';
                                    }}
                                />
                                <div>
                                    <h4 className="text-lg font-medium text-gray-900">
                                        {isMoreInfoData.advertiser?.name || 'N/A'}
                                    </h4>
                                    <p className="text-sm text-gray-500">
                                        {isMoreInfoData.advertiser?.email || 'N/A'}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Transaction Info */}
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Transaction ID</h4>
                            <p className="mt-1 text-sm text-gray-900">{isMoreInfoData._id}</p>
                        </div>
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Order Status</h4>
                            <div className="mt-1 flex items-center">
                                <span className={`inline-block h-2 w-2 rounded-full mr-2 ${isMoreInfoData.orderStatus === 'CANCELLED' ? 'bg-red-500' : 'bg-green-500'
                                    }`}></span>
                                <span className="text-sm capitalize">{isMoreInfoData.orderStatus}</span>
                            </div>
                        </div>
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Asset</h4>
                            <p className="mt-1 text-sm text-gray-900">{isMoreInfoData.adId?.asset || 'N/A'}</p>
                        </div>
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Fiat Currency</h4>
                            <p className="mt-1 text-sm text-gray-900">{isMoreInfoData.adId?.fiatCurrency || 'N/A'}</p>
                        </div>
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Trade Rate</h4>
                            <p className="mt-1 text-sm text-gray-900">
                                {isMoreInfoData.tradeRate?.toFixed(4) || 'N/A'}
                            </p>
                        </div>
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Trade Amount</h4>
                            <p className="mt-1 text-sm text-gray-900">
                                {isMoreInfoData.tradeAmount?.toFixed(4) || 'N/A'} {isMoreInfoData.currency}
                            </p>
                        </div>
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Payment Method</h4>
                            <p className="mt-1 text-sm text-gray-900">
                                {isMoreInfoData.payMethod?.methodShortName} ({isMoreInfoData.payMethod?.methodType})
                            </p>
                        </div>
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Order Type</h4>
                            <p className="mt-1 text-sm text-gray-900 capitalize">
                                {isMoreInfoData.orderType || 'N/A'}
                            </p>
                        </div>
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Time Limit</h4>
                            <p className="mt-1 text-sm text-gray-900">
                                {isMoreInfoData.adId?.tradeLimitTime || 'N/A'} minutes
                            </p>
                        </div>
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Escrow Status</h4>
                            <p className="mt-1 text-sm text-gray-900 capitalize">
                                {isMoreInfoData.escrowStatus || 'N/A'}
                            </p>
                        </div>
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Created At</h4>
                            <p className="mt-1 text-sm text-gray-900">
                                {new Date(isMoreInfoData.createdAt).toLocaleString()}
                            </p>
                        </div>
                        <div>
                            <h4 className="text-sm font-medium text-gray-500">Updated At</h4>
                            <p className="mt-1 text-sm text-gray-900">
                                {new Date(isMoreInfoData.updatedAt).toLocaleString()}
                            </p>
                        </div>

                        {/* Verification Requirements */}
                        {Array.isArray(isMoreInfoData.adId?.tradeTerms) && isMoreInfoData.adId.tradeTerms.length > 0 && (
                            <div className="sm:col-span-2">
                                <h4 className="text-sm font-medium text-gray-500">Verification Requirements</h4>
                                <p className="mt-1 text-sm text-yellow-600">
                                    This transaction requires identity verification
                                </p>
                            </div>
                        )}

                        {/* Stats */}
                        <div className="sm:col-span-2 border-t border-gray-200 pt-4">
                            <div className="grid grid-cols-3 gap-4 text-center">
                                <div>
                                    <h4 className="text-sm font-medium text-gray-500">Total Orders</h4>
                                    <p className="mt-1 text-lg font-medium text-gray-900">
                                        {isMoreInfoData.totalOrders || '0'}
                                    </p>
                                </div>
                                <div>
                                    <h4 className="text-sm font-medium text-gray-500">Completed</h4>
                                    <p className="mt-1 text-lg font-medium text-gray-900">
                                        {isMoreInfoData.totalCompleteOrder || '0'}
                                    </p>
                                </div>
                                <div>
                                    <h4 className="text-sm font-medium text-gray-500">Rating</h4>
                                    <p className="mt-1 text-lg font-medium text-gray-900">
                                        {calculatePositiveRating(
                                            isMoreInfoData.totalOrders,
                                            isMoreInfoData.positiveRatings
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewMoreInfo